var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4153_12798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "rgba(118, 118, 118, 1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4153_12798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 12.25C3.7612 12.25 3.48655 12.1358 3.25807 11.9073C3.0296 11.6788 2.91536 11.4042 2.91536 11.0833V3.5H2.33203V2.33333H5.2487V1.75H8.7487V2.33333H11.6654V3.5H11.082V11.0833C11.082 11.4042 10.9678 11.6788 10.7393 11.9073C10.5109 12.1358 10.2362 12.25 9.91537 12.25H4.08203ZM9.91537 3.5H4.08203V11.0833H9.91537V3.5ZM5.2487 9.91667H6.41536V4.66667H5.2487V9.91667ZM7.58203 9.91667H8.7487V4.66667H7.58203V9.91667Z",
    fill: "rgba(118, 118, 118, 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSecondary);
export default __webpack_public_path__ + "static/media/TrashSecondary.36a7eafdfdf92fd4f243249bff570c0b.svg";
export { ForwardRef as ReactComponent };